import React, { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import Select from 'react-select';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AfficheReservation } from '../../Api/RestaurantApi/AnaliticApi';
import './css/analiticResto.css';

const Analitics = () => {

  const [loadData, setLoadData] = useState(false);
  const [totalResa, setTotalResa] = useState([]);

  let location = useLocation();

  const restaurant = useSelector((state) => state.restaurant);


  const [anner, setAnner] = useState([]);


  const [data, setData] = useState([]);

  const [note, setNote] = useState([]);





  useEffect(() => {
    listeAnne();
  }, []);

  useEffect(() => {
    listeReservation();
  }, []);

  const filterMois = (value) => {
    if (value === "Jan") {
      return "Janvier";
    } else if (value === "Feb") {
      return "Fevrier";
    } else if (value === "Mar") {
      return "Mars";
    } else if (value === "May") {
      return "May";
    } else if (value === "Jun") {
      return "Juin";
    } else if (value === "Jul") {
      return "Juillet";
    } else if (value === "Aug") {
      return "Août";
    } else if (value === "Sep") {
      return "Septembre";
    } else if (value === "Oct") {
      return "Octobre";
    } else if (value === "Nov") {
      return "Novembre";
    } else {
      return "Decembre";
    }
  }



const listeAnne=()=>{
  AfficheReservation(restaurant.id).then(function (response) {
    console.log('affiche Les reservations =>', response.data.donner);
    setTotalResa(response.data.donner);
    const valueAnner = [];
    response.data.donner.forEach((el) => {
      let existeAnner = valueAnner.find((element) => element.value === el.anne);
      if (existeAnner) {
        console.log("Anner existe ");
      } else {
        valueAnner.push({ value: el.anne, label: el.anne });
      }
    });
    console.log("Value anner =>", valueAnner);
    setAnner(valueAnner);
  });
}


  const listeReservation = () => {
    setLoadData(true);
    AfficheReservation(restaurant.id).then(function (response) {
      console.log('affiche Les reservations =>', response.data.donner);
      setTotalResa(response.data.donner);
      const reservationData = [];

      response.data.donner.forEach((el) => {
        let existeResa = reservationData.find((element) => element.Mois === filterMois(el.mois));
        if (existeResa) {
          console.log("Resa existe ");
        } else {
          let valeurResa = response.data.donner.filter((value) => value.mois === el.mois);
          let valuerCouverte = valeurResa.reduce((previous, current, index) => previous + parseInt(current.nombrePersonne), 0);
          let nouvaux = valeurResa.filter((value) => value.dejasVenus === "Non");
          let encien = valeurResa.filter((value) => value.dejasVenus === "Oui");
          reservationData.push({ Mois: filterMois(el.mois), Réservation: valeurResa.length, Couverte: valuerCouverte, Nouvaux: nouvaux.length, Encien: encien.length });
        }
      });
      console.log("Value Resa analitics =>", reservationData);

      setData(reservationData);

      const valueNote = [];

      response.data.donner.forEach((el) => {
        let existeNote = valueNote.find((element) => element.Mois === filterMois(el.mois));
        if (existeNote) {
          console.log("Note existe ");
        } else {
          let valeurResa = response.data.donner.filter((value) => value.mois === el.mois && value.notes.length !== 0);
          let noteReduce = valeurResa.reduce((previous, current) => previous + parseFloat(current.notes[0]?.note), 0) / valeurResa.length;
          console.log("noteReduce =>", noteReduce);

          // Vérifie si noteReduce est NaN et remplace-le par 0
          const note = typeof noteReduce === 'number' && !Number.isNaN(noteReduce) ? noteReduce : 0;
          
          valueNote.push({ Mois: filterMois(el.mois), Note: note });
        }
      });
      console.log("Value Note =>", valueNote);

      setNote(valueNote);

    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }





  const CustomizedDot = (props) => {
    const { cx, cy, stroke, payload, value } = props;

    if (value < 10) {
      return (
        <svg x={cx - 10} y={cy - 10} width={20} height={20} fill="red" viewBox="0 0 1024 1024">
          <path d="M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z" />
        </svg>

      );
    }
    return (
      <svg x={cx - 10} y={cy - 10} width={20} height={20} fill="#82ca9d" viewBox="0 0 1024 1024">
        <path d="M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z" />
      </svg>
    );
  };

  const handleAnne = (value) => {
    const nouvelleResa = totalResa.filter((el) => el.anne === value);
    // const valueAnner = [];

    // nouvelleResa.forEach((el) => {
    //   let existeAnner = valueAnner.find((element) => element.value === el.anne);
    //   if (existeAnner) {
    //     console.log("Anner existe ");
    //   } else {
    //     valueAnner.push({ value: el.anne, label: el.anne });
    //   }
    // });
    // console.log("Value anner =>", valueAnner);
    // setAnner(valueAnner);


    const reservationData = [];

    nouvelleResa.forEach((el) => {
      let existeResa = reservationData.find((element) => element.Mois === filterMois(el.mois));
      if (existeResa) {
        console.log("Resa existe ");
      } else {
        let valeurResa = nouvelleResa.filter((value) => value.mois === el.mois);
        let valuerCouverte = valeurResa.reduce((previous, current, index) => previous + parseInt(current.nombrePersonne), 0);
        let nouvaux = valeurResa.filter((value) => value.dejasVenus === "Non");
        let encien = valeurResa.filter((value) => value.dejasVenus === "Oui");
        reservationData.push({ Mois: filterMois(el.mois), Réservation: valeurResa.length, Couverte: valuerCouverte, Nouvaux: nouvaux.length, Encien: encien.length });
      }
    });
    console.log("Value Resa analitics =>", reservationData);

    setData(reservationData);

    const valueNote = [];

    nouvelleResa.forEach((el) => {
      let existeNote = valueNote.find((element) => element.Mois === filterMois(el.mois));
      if (existeNote) {
        console.log("Note existe ");
      } else {
        let valeurResa = nouvelleResa.filter((value) => value.mois === el.mois && value.notes.length !== 0);
        let noteReduce = valeurResa.reduce((previous, current) => previous + parseFloat(current.notes[0]?.note), 0) / valeurResa.length;
        const note = typeof noteReduce === 'number' && !Number.isNaN(noteReduce) ? noteReduce : 0;   
        valueNote.push({ Mois: filterMois(el.mois), Note: note });
      }
    });
    console.log("Value Note =>", valueNote);

    setNote(valueNote);
  }


  return (
    <div>
      <Helmet>
        <title>Analitics</title>
        <meta name='description' content='Restaurant analitics.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='analitic'>
        <div className='container'>
          <div className='bloc_analitic'>
            <div className='analitic_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-bar-chart'></i> <h1>Analitics</h1>
              </div>
              <div className='analitic_renseignement'>
                <p>Paramétrage des services, des jours et heures d’ouverture, ainsi que les congés et fermetures exceptionnelles.
                  Dès connaissance, et au plus tôt, pensez à saisir les jours de fermeture afin d’éviter la prise de réservation sur ces créneaux.
                  Veillez à mettre à jour cette page lors de vos changements liés aux services et/ou heure et jour d’ouverture.
                </p>
              </div>
            </div>
            <div className='analitic_content_reservation'>
              <div className='d-flex justify-content-center mb-4'>
                <Select
                  placeholder="Année ..."
                  onChange={(e) => handleAnne(e.value)}
                  options={anner} />

              </div>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart

                  data={data}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 0,
                    bottom: 20
                  }}
                >
                  <CartesianGrid strokeDasharray="2 2" />
                  <XAxis dataKey="Mois" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="Réservation" fill="#4ba7cc" />
                  <Bar dataKey="Couverte" fill="#f7e958" />
                  <Bar dataKey="Encien" fill="grey" />
                  <Bar dataKey="Nouvaux" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className='analitic_content_note'>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart
                  data={note}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 0,
                    bottom: 20
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="Mois" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line dataKey="Note" stroke="#4ba7cc" fill="#4ba7cc" dot={<CustomizedDot />} />
                </LineChart>
              </ResponsiveContainer>
              <p className='version'>Version 1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Analitics